var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateFare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_2852",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#6A7878"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_2852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88451 20.5771C3.46284 20.5771 3.10426 20.4294 2.80876 20.1339C2.51326 19.8382 2.36551 19.4796 2.36551 19.0579V4.59615C2.36551 4.17448 2.51326 3.8159 2.80876 3.5204C3.10426 3.2249 3.46284 3.07715 3.88451 3.07715H10.3463C10.7679 3.07715 11.1265 3.2249 11.422 3.5204C11.7175 3.8159 11.8653 4.17448 11.8653 4.59615V7.07715H20.1155C20.5372 7.07715 20.8958 7.2249 21.1913 7.5204C21.4868 7.8159 21.6345 8.17448 21.6345 8.59615V19.0579C21.6345 19.4796 21.4868 19.8382 21.1913 20.1339C20.8958 20.4294 20.5372 20.5771 20.1155 20.5771H3.88451ZM3.86526 19.0771H10.3655V16.5771H3.86526V19.0771ZM3.86526 15.0771H10.3655V12.5771H3.86526V15.0771ZM3.86526 11.0771H10.3655V8.57715H3.86526V11.0771ZM3.86526 7.07715H10.3655V4.57715H3.86526V7.07715ZM11.8653 19.0771H20.1348V8.57715H11.8653V19.0771ZM14.8078 12.5771C14.5953 12.5771 14.4171 12.5052 14.2733 12.3614C14.1296 12.2176 14.0578 12.0393 14.0578 11.8266C14.0578 11.6141 14.1296 11.4361 14.2733 11.2924C14.4171 11.1489 14.5953 11.0771 14.8078 11.0771H17C17.2125 11.0771 17.3906 11.1491 17.5343 11.2929C17.6781 11.4366 17.75 11.6147 17.75 11.8274C17.75 12.0401 17.6781 12.2181 17.5343 12.3616C17.3906 12.5053 17.2125 12.5771 17 12.5771H14.8078ZM14.8078 16.5771C14.5953 16.5771 14.4171 16.5052 14.2733 16.3614C14.1296 16.2176 14.0578 16.0393 14.0578 15.8266C14.0578 15.6141 14.1296 15.4361 14.2733 15.2924C14.4171 15.1489 14.5953 15.0771 14.8078 15.0771H17C17.2125 15.0771 17.3906 15.1491 17.5343 15.2929C17.6781 15.4366 17.75 15.6147 17.75 15.8274C17.75 16.0401 17.6781 16.2181 17.5343 16.3616C17.3906 16.5053 17.2125 16.5771 17 16.5771H14.8078Z",
    fill: "#6A7878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateFare);
export default __webpack_public_path__ + "static/media/corporate_fare.f6235280c432a2094713d3e290498e45.svg";
export { ForwardRef as ReactComponent };